import { render } from "./recommendItem.vue?vue&type=template&id=5849be9b&scoped=true"
import script from "./recommendItem.vue?vue&type=script&lang=js"
export * from "./recommendItem.vue?vue&type=script&lang=js"

import "./recommendItem.vue?vue&type=style&index=0&id=5849be9b&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5849be9b"]])

export default __exports__